// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2e-Tv","name":"ConsentHeader_name__DGY7g","birthday":"ConsentHeader_birthday__2klSS","skeleton":"ConsentHeader_skeleton__pMDeK"};